import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Gallery from "./components/Gallery";
import About from "./components/About";
import Location from "./components/Location";
import JahorinaWinter from "./components/JahorinaWinter";
import Attractions from "./components/Attractions";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import Reservation from "./components/Reservation";
import Footer from "./components/Footer";
import SkierAnimation from "./components/SkierAnimation";

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <SkierAnimation />
      <Header />
      <Hero />
      <Gallery />
      <About />
      <Location />
      <JahorinaWinter />
      <Attractions />
      <FAQ />
      <Contact />
      <Reservation />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;